export enum SapiHttpHeader {
    ACCEPT = 'Accept',
    API_KEY = 'X-Admin-Api-Key',
    CONTENT_TYPE = 'Content-Type'
}

